var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawSuccessFactorsI417({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 837.472,
    height: 599.272,
    viewBox: "0 0 837.472 599.272",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_289",
    "data-name": "Group 289",
    transform: "translate(-516.063 -308.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4955-533",
    "data-name": "Path 4955",
    d: "M128.877,561.183H0V559.1H128.935Z",
    transform: "translate(1211.898 343.824)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4981-534",
    "data-name": "Path 4981",
    d: "M783.9,566.059l-5.716,12.385-10.48-.953-6.668-21.912,10.479-5.716Z",
    transform: "translate(473.411 277.725)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4982-535",
    "data-name": "Path 4982",
    d: "M822.424,597.184l.226,8.631-16.2.953v-10.48Z",
    transform: "translate(470.866 275.123)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4983-536",
    "data-name": "Path 4983",
    d: "M814.784,429.98l-3.811,76.214,9.527,82.884-28.581,3.811-18.1-104.8L768.1,416.642Z",
    transform: "translate(473.016 285.191)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4984-537",
    "data-name": "Path 4984",
    d: "M1015.622,523.173s11.432,75.262-12.385,100.032S947.029,691.8,947.029,691.8l-22.864-28.581,58.114-61.924-11.432-41.918-46.682-21.912,7.622-52.4,68.593-.953Z",
    transform: "translate(316.953 164.371)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_851",
    "data-name": "Ellipse 851",
    cx: 20.959,
    cy: 20.959,
    r: 20.959,
    transform: "translate(1255.408 471.285)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4985-538",
    "data-name": "Path 4985",
    d: "M979.155,323.643s.953,29.533,5.716,33.344-17.148,20.006-17.148,20.006l-14.29-22.864V333.17Z",
    transform: "translate(315.313 173.363)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4986-539",
    "data-name": "Path 4986",
    d: "M812.718,241.006l11.566-17.465,6.534,8.891,9.527,26.675-7.622,103.842-44.777.953-5.716-119.086,14.29-17.148Z",
    transform: "translate(472.224 296.014)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4987-540",
    "data-name": "Path 4987",
    d: "M917.761,373.039l-7.622-.953s-1.905.953-2.858,7.621S894.9,445.443,894.9,445.443l15.243,72.4,17.148-22.864L916.808,454.97l10.48-40.013Z",
    transform: "translate(318.594 170.648)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4988-541",
    "data-name": "Path 4988",
    d: "M865.32,248.1h5.716l14.291,77.167-13.337,60.02-13.338-21.912,3.811-23.817-1.9-20.959-6.669-12.386Z",
    transform: "translate(468.208 294.637)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4989-542",
    "data-name": "Path 4989",
    d: "M930.618,698.564s5.716-1.905,5.716,1.905-3.811,15.243-3.811,15.243,5.716,35.249-2.858,33.344-15.243-18.1-16.2-22.864-5.716-29.533-5.716-29.533-7.621-18.1-2.858-19.054,18.1-4.763,18.1-4.763S915.375,696.658,930.618,698.564Z",
    transform: "translate(318.121 153.795)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4990-543",
    "data-name": "Path 4990",
    d: "M961.273,731.089s15.243-9.527,18.1-1.905a80.049,80.049,0,0,1,3.811,17.148s3.811,12.385-11.432,10.48-13.338-1.905-14.29-7.622S961.273,731.089,961.273,731.089Z",
    transform: "translate(315.095 150.803)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4991-544",
    "data-name": "Path 4991",
    d: "M972.421,316.668l-3.811-.953s-2.858-16.2-9.527-14.29-23.817,3.811-23.817-3.811,16.2-14.29,25.722-13.338,25.722,3.811,24.77,18.1-7.1,28.192-7.1,28.192l-.5-8.473Z",
    transform: "translate(316.331 175.576)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4994-545",
    "data-name": "Path 4994",
    d: "M912.053,370.87l30.486-12.385,7.145-5.24,21.435,94.792,14.29-42.871-4.287-54.779,39.536,20.483-13.338,64.783-1.905,24.77,5.716,20.006s20.006,14.29,13.337,29.533-14.29,16.2-14.29,16.2-32.391-30.486-34.3-38.107-4.763-20.959-4.763-20.959-16.2,60.972-35.249,60.019-19.054-20.959-19.054-20.959l4.763-20.959,7.621-21.912-3.811-36.2Z",
    transform: "translate(317.632 171.865)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_967-546",
    "data-name": "Rectangle 967",
    d: "M0,0H664.145a0,0,0,0,1,0,0V417.348a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(516.346 308.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_968",
    "data-name": "Rectangle 968",
    width: 626.163,
    height: 162.146,
    transform: "translate(535.337 362.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_969",
    "data-name": "Rectangle 969",
    width: 132.42,
    height: 7.601,
    transform: "translate(691.089 385.688)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_970",
    "data-name": "Rectangle 970",
    width: 204.485,
    height: 7.601,
    transform: "translate(691.089 413.416)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_971",
    "data-name": "Rectangle 971",
    width: 166.65,
    height: 7.601,
    transform: "translate(691.089 439.539)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_972",
    "data-name": "Rectangle 972",
    width: 97.288,
    height: 7.601,
    transform: "translate(691.089 465.564)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_973",
    "data-name": "Rectangle 973",
    width: 146.833,
    height: 7.601,
    transform: "translate(691.089 491.59)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_974",
    "data-name": "Rectangle 974",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 382.986)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_975",
    "data-name": "Rectangle 975",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 409.109)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 435.232)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_977",
    "data-name": "Rectangle 977",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 461.355)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_978",
    "data-name": "Rectangle 978",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 487.48)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    width: 54.049,
    height: 54.049,
    transform: "translate(1019.885 419.918)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    width: 626.163,
    height: 162.146,
    transform: "translate(535.337 546.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    width: 16.215,
    height: 16.215,
    transform: "translate(658.66 587.873)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    width: 16.215,
    height: 16.215,
    transform: "translate(630.734 587.873)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4995-547",
    "data-name": "Path 4995",
    d: "M562.667,427.26a61.4,61.4,0,0,0-99.118-9.156l-3.952-3.453a66.638,66.638,0,0,1,107.586,9.936Z",
    transform: "translate(342.989 169.543)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4996-548",
    "data-name": "Path 4996",
    d: "M571.147,497.565l-4.355-2.928a61.43,61.43,0,0,0,1.882-65.432l4.516-2.673A66.679,66.679,0,0,1,571.147,497.565Z",
    transform: "translate(336.981 167.598)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4997-549",
    "data-name": "Path 4997",
    d: "M459.167,504.285a66.633,66.633,0,0,1-.547-88.28l3.952,3.453a61.386,61.386,0,0,0,.5,81.326Z",
    transform: "translate(343.966 168.188)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4998-550",
    "data-name": "Path 4998",
    d: "M509.828,531.115a66.746,66.746,0,0,1-49.652-22.2l3.909-3.5a61.4,61.4,0,0,0,96.733-6.738l4.355,2.928a66.6,66.6,0,0,1-55.344,29.507Z",
    transform: "translate(342.957 163.555)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_983",
    "data-name": "Rectangle 983",
    width: 54.049,
    height: 54.049,
    transform: "translate(1019.885 596.479)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_985-551",
    "data-name": "Rectangle 985",
    d: "M8,0H656.145a8,8,0,0,1,8,8V28.215a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V8A8,8,0,0,1,8,0Z",
    transform: "translate(516.063 308.541)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_852",
    "data-name": "Ellipse 852",
    cx: 5.229,
    cy: 5.229,
    r: 5.229,
    transform: "translate(531.8 317.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_853",
    "data-name": "Ellipse 853",
    cx: 5.229,
    cy: 5.229,
    r: 5.229,
    transform: "translate(551.649 317.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_854",
    "data-name": "Ellipse 854",
    cx: 5.229,
    cy: 5.229,
    r: 5.229,
    transform: "translate(571.5 317.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_986",
    "data-name": "Rectangle 986",
    width: 81.288,
    height: 7.601,
    transform: "translate(630.734 619.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    width: 95.288,
    height: 7.601,
    transform: "translate(630.734 635.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 81.288,
    height: 7.601,
    transform: "translate(630.734 651.531)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSuccessFactorsI417);
export default __webpack_public_path__ + "static/media/undraw_success-factors_i417.2af6f4589b4f310173720bf69b643ab9.svg";
export { ForwardRef as ReactComponent };